<template>
  <div class="columns is-mobile is-multiline is-justify-content-flex-end">
    <div class="column is-12-mobile is-narrow-tablet">
      <b-button expanded tag="router-link" type="is-success" :to="{ name: 'queclinkTracker.add' }">
        <b-icon icon="plus" size="is-small" />
        <span>Nouveau</span>
      </b-button>
    </div>
    <div class="column is-12-mobile is-narrow-tablet ml-auto">
      <import-csv
        expanded
        :format="csvHeader"
        :loading="loading"
        label="Modifier les propriétaires (CSV)"
        @submit="$emit('import', $event)"
      />
    </div>
    <div class="column is-12-mobile is-narrow-tablet">
      <b-button
        expanded
        type="is-outlined"
        class="has-background-light"
        icon-left="file-export"
        :disabled="loading || queclinkTrackers.length === 0"
        label="Export CSV"
        @click="exportCsv"
      />
    </div>
    <div class="column is-12-mobile is-narrow-tablet">
      <b-button
        expanded
        type="is-info"
        icon-left="sync"
        label="Synchroniser le planning"
        :disabled="loading"
        :loading="syncing"
        @click="syncSheet"
      />
    </div>
  </div>
</template>

<script>
import ImportCsv from '@components/ImportCsv.vue'
import { AVAILABILITIES } from '@constants/tracker/availability'
import { downloadFile } from '@helpers/downloadFile'
import { formatCSV } from '@helpers/csv'
import { mapActions } from 'vuex'

export default {
  name: 'ListQueclinkTrackersAction',

  components: {
    ImportCsv,
  },

  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    queclinkTrackers: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      syncing: false,
      csvHeader: {
        line: 'Line',
        number: 'Number',
        owner: 'Owner',
      },
    }
  },

  methods: {
    ...mapActions('ui', ['addToastMessage']),

    async syncSheet() {
      this.syncing = true

      try {
        const { updatedRows, createdRows } = await this.$services.queclinkTrackerService.syncSheet()

        this.addToastMessage({
          text: `Planning synchronisé : ${updatedRows} mise(s) à jour, ${createdRows} ajout(s).`,
          type: 'is-success',
        })
      } catch (err) {
        this.addToastMessage({
          text: err.message || 'Erreur lors de la synchronisation du planning.',
          type: 'is-danger',
        })
        console.error(err)
      }

      this.syncing = false
    },

    exportCsv() {
      const data = this.queclinkTrackers.map((tracker, index) => [
        index + 1,
        tracker.number,
        tracker.imei,
        AVAILABILITIES[tracker.availability],
        tracker.owner,
      ])
      data.unshift(['Line', 'Number', 'IMEI', 'Status', 'Owner'])

      downloadFile(formatCSV(data), 'csv', 'queclink-trackers')
    },
  },
}
</script>
